import { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import EventsSection from "../components/EventsSection";
import PricingSection from "../components/PricingSection";
import PastEventsSection from "../components/PastEventsSection";
import CyberAwarenessSection from "../components/CyberAwarenessSection";
import AboutSection from "../components/AboutSection";
import SponsorsSection from "../components/SponsorsSection";
import FAQSection from "../components/FAQSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import VisitorCounter from "../components/VisitorCounter";
import CountdownTimer from "../components/CountdownTimer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const HomePage = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${API}/events`);
        setEvents(response.data.events);
      } catch (e) {
        console.error("Error fetching events:", e);
      }
    };
    fetchEvents();
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="home-page">
      <Navbar />
      <HeroSection />
      <EventsSection events={events} />
      <PricingSection />
      <PastEventsSection />
      <CyberAwarenessSection />
      <AboutSection />
      <SponsorsSection />
      <FAQSection />
      <ContactSection />
      
      {/* Event Countdown Timer - Fixed at bottom for reference */}
      <div className="bg-[#111827] py-8">
        <div className="container-custom">
          <div className="text-center text-white mb-4">
            <p className="text-sm text-gray-400 uppercase tracking-wider mb-2">Event Countdown</p>
            <h3 className="text-2xl font-bold font-['Outfit']">The FinRun Hyderabad 2027</h3>
            <p className="text-gray-400">February 7, 2027 • Gachibowli Stadium</p>
          </div>
          <div className="max-w-md mx-auto">
            <CountdownTimer 
              targetDate="2027-02-07T05:30:00"
              eventName=""
            />
          </div>
        </div>
      </div>
      
      <Footer />
      <VisitorCounter />
    </div>
  );
};

export default HomePage;
